import "./DelegateCard.scss";
import { useRef } from "react";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import { Col, Region, Row } from "@/components";
import { CheckIcon } from "@/icons";

export type DelegateCardProps = {
  id: string;
  isSelected: boolean;
  title: string;
  subtitle: string;
  relation: string;
  isMe?: boolean;
  setSelectedCard: (id: string) => void;
  className?: string;
  showRegion?: boolean;
  region?: Region;
  labelRelation?: string;
  labelRegion?: string;
  labelRecord?: string;
};

export const DelegateCard = ({
  id,
  isSelected,
  title,
  subtitle,
  region,
  relation,
  isMe = false,
  showRegion = false,
  setSelectedCard = () => {},
  className,
  labelRelation = "Relazione con il delegante",
  labelRegion = "Regione di assistenza",
  labelRecord = "IL TUO FASCICOLO",
}: DelegateCardProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const firstLetterUppercase = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <Row
      br={"x4"}
      p={"x24"}
      gap={"x16"}
      bg={"white"}
      text={"slate-20"}
      ref={dropdownRef}
      className={`${className} ${isSelected ? "ui-is-active" : ""} ui-card-delegate shadow cursor-pointer`}
      onClick={() => {
        setSelectedCard(id);
      }}
      style={{ width: "100%" }}
    >
      <div className={"mt-x4"}>
        <CheckboxRadix.Root
          id={id}
          checked={isSelected}
          className={"ui-checkbox-filter"}
        >
          <CheckboxRadix.Indicator>
            <CheckIcon width={14} height={14} color="white" />
          </CheckboxRadix.Indicator>
        </CheckboxRadix.Root>
      </div>

      <Row
        alignItems={"flex-start"}
        style={{ width: "100%" }}
        justifyContent={"space-between"}
      >
        <Col style={{ flex: 1 }} justifyContent={"center"} className={`w-full`}>
          <Col
            gap={"x4"}
            pb={
              (isMe || (!isMe && !relation)) && !showRegion ? undefined : "x16"
            }
          >
            <h1 className="flex-1 text-decoration-none fs-4 md-fs-3 fw-semibold">
              {title}
            </h1>
            <p className="fs-6 fw-normal text-slate-28">{subtitle}</p>
          </Col>
          <Col gap={"x24"} className="delegate-row-responsive">
            {!isMe && relation && (
              <Col gap={"x4"}>
                <div className={"fw-bold"}>{labelRelation}</div>
                <p>{relation}</p>
              </Col>
            )}
            {showRegion && region && (
              <Col pr={"x104"} gap={"x4"}>
                <div className={"fw-bold"}>{labelRegion}</div>
                <p>{firstLetterUppercase(region)}</p>
              </Col>
            )}
          </Col>
          {isMe && (
            <Row className={"ui-fascicolo-label fs-7 fw-semibold"}>
              {labelRecord}
            </Row>
          )}
        </Col>
      </Row>
    </Row>
  );
};
